import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { string_type, class_type, record_type, bool_type, lambda_type, unit_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { GlobalMessageType, GlobalMsg, GlobalMessageBox_Error_Z721C83C5, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Dashboard_VertragBestaetigungRequest, Dashboard_VertragBestaetigung, Dashboard_VertragBestaetigungRequest_$reflection, Dashboard_VertragBestaetigung_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FormField__get_IsValid, update as update_1, ValidationRule, FormField_InitWithDefault_74789EBD, FormField_$reflection } from "../../../../Bfs.Web.Portale/Validation.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { ofArray, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { createObj, int32ToString, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { value as value_10, map, defaultArg } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { containsKey } from "../../../fable_modules/fable-library-js.4.19.0/Map.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { NotificationTile_NotificationTileProps, NotificationTile_view } from "./Shared.fs.js";
import { createElement } from "react";
import * as react from "react";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";
import { singleton as singleton_1, append as append_1, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { isNullOrEmpty } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { messageBoxComponent } from "../../../../Bfs.Web.Portale/Template.fs.js";
import { reactApi } from "../../../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { DOMAttr, DangerousHtml, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Markdown_ToHtml_1BFEAEDB } from "../../../fable_modules/Fable.Formatting.Markdown.1.0.1/Markdown.fs.js";
import { validatedTextBox } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";

export class ShowVertragsDialog extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ShowContractAndTile", "ShowTileOnly", "ShowConfirmation", "DoNotShowAnything"];
    }
}

export function ShowVertragsDialog_$reflection() {
    return union_type("Dashboard.VertragsBestaetigung.ShowVertragsDialog", [], ShowVertragsDialog, () => [[], [], [], []]);
}

export class Model extends Record {
    constructor(GlobalDispatch, Loading, AlreadySeen, Data, ShowVertragsDialog, Name) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.Loading = Loading;
        this.AlreadySeen = AlreadySeen;
        this.Data = Data;
        this.ShowVertragsDialog = ShowVertragsDialog;
        this.Name = Name;
    }
}

export function Model_$reflection() {
    return record_type("Dashboard.VertragsBestaetigung.Model", [], Model, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["Loading", bool_type], ["AlreadySeen", bool_type], ["Data", Dashboard_VertragBestaetigung_$reflection()], ["ShowVertragsDialog", ShowVertragsDialog_$reflection()], ["Name", FormField_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadData", "LoadDataCompleted", "NameChanged", "VertragAktualisieren", "CloseModal", "VertragAkzeptiert", "SetDataCompleted", "ConfirmVertrag"];
    }
}

export function Msg_$reflection() {
    return union_type("Dashboard.VertragsBestaetigung.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Dashboard_VertragBestaetigung_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Dashboard_VertragBestaetigung_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", string_type]], [], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], []]);
}

export function Http_loadData() {
    const response = fetch("/api/dashboard/vertragsbestaetigung", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Dashboard_VertragBestaetigung_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_setNewVertragsbestaetigung(payload) {
    return sendJson("/api/dashboard/vertragsbestaetigung", toString(0, Auto_generateBoxedEncoder_437914C6(Dashboard_VertragBestaetigungRequest_$reflection(), undefined, undefined, undefined)(payload)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export const State_SESSION_DATA_KEY_INFO_BOX_ALREADYSEEN = "VertragsBestaetigungInfoBoxAlreadySeen";

export function State_init(props, userName, user) {
    return [new Model(props.GlobalDispatch, true, defaultArg(map((u) => containsKey(State_SESSION_DATA_KEY_INFO_BOX_ALREADYSEEN, u.SessionData), user), false), new Dashboard_VertragBestaetigung("", "", "", ""), new ShowVertragsDialog(3, []), FormField_InitWithDefault_74789EBD(new ValidationRule(0, []), userName)), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Es kann derzeit nicht geprüft werden, ob ein Vertrag bestätigt werden muss.")]));
                return [new Model(model.GlobalDispatch, false, model.AlreadySeen, model.Data, model.ShowVertragsDialog, model.Name), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, false, model.AlreadySeen, msg.fields[0].fields[0], (msg.fields[0].fields[0].VertragsNummer === "") ? (new ShowVertragsDialog(3, [])) : (model.AlreadySeen ? (new ShowVertragsDialog(3, [])) : (new ShowVertragsDialog(1, []))), model.Name), Cmd_none()];
            }
        case 3:
            return [new Model(model.GlobalDispatch, model.Loading, model.AlreadySeen, model.Data, new ShowVertragsDialog(0, []), model.Name), Cmd_none()];
        case 4:
            return [new Model(model.GlobalDispatch, model.Loading, model.AlreadySeen, model.Data, new ShowVertragsDialog(1, []), model.Name), Cmd_none()];
        case 5:
            return [new Model(model.GlobalDispatch, model.Loading, model.AlreadySeen, model.Data, new ShowVertragsDialog(2, []), model.Name), request(Http_setNewVertragsbestaetigung, new Dashboard_VertragBestaetigungRequest(model.Data.VertragsNummer, model.Name.Value), (Item_2) => (new Msg(6, [Item_2])))];
        case 6:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Die Vertragsbestätigung kann momentan nicht gespeichert werden.")]));
                return [new Model(model.GlobalDispatch, model.Loading, model.AlreadySeen, model.Data, new ShowVertragsDialog(1, []), model.Name), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, model.Loading, model.AlreadySeen, model.Data, new ShowVertragsDialog(2, []), model.Name), Cmd_none()];
            }
        case 7:
            return [new Model(model.GlobalDispatch, model.Loading, model.AlreadySeen, model.Data, new ShowVertragsDialog(3, []), model.Name), Cmd_none()];
        case 2:
            return [new Model(model.GlobalDispatch, model.Loading, model.AlreadySeen, model.Data, model.ShowVertragsDialog, update_1(model.Name, msg.fields[0])), Cmd_none()];
        default:
            return [new Model(model.GlobalDispatch, true, model.AlreadySeen, model.Data, model.ShowVertragsDialog, model.Name), request(Http_loadData, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

export function newNavigationTile(model, dispatch, userSession, props) {
    let children_8, children_6;
    return NotificationTile_view(new NotificationTile_NotificationTileProps(props.GlobalDispatch, State_SESSION_DATA_KEY_INFO_BOX_ALREADYSEEN, "Wichtig", "Wir aktualisieren unsere Vereinbarung.", (children_8 = [react.createElement("div", {
        className: "column",
    }, model.Data.VertragsTeaser), (children_6 = [react.createElement("a", {
        className: "show-more",
        onClick: (_arg) => {
            dispatch(new Msg(3, []));
        },
    }, "Mehr anzeigen"), react.createElement("button", {
        className: "button is-bfsorange",
        onClick: (_arg_1) => {
            dispatch(new Msg(3, []));
        },
    }, "Jetzt aktualisieren")], react.createElement("div", {
        className: "column is-narrow vertrags-buttons",
    }, ...children_6))], react.createElement("div", {
        className: "columns",
    }, ...children_8)), userSession));
}

export const view = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_10("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Dashboard\\VertragsBestaetigung.fs") + "#L") + int32ToString(value_10(178))) + ";") + "System.Tuple`3[Dashboard.Shared.DashboardProps,System.String,Microsoft.FSharp.Core.FSharpOption`1[Types.UserSession]]", value_10("view"), (tupledArg) => {
    const props = tupledArg[0];
    const userSession = tupledArg[2];
    let patternInput;
    const init = State_init(props, tupledArg[1], userSession);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, State_update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const children_18 = toList(delay(() => {
        let children_12, children_10, s_5;
        const matchValue = model_1.ShowVertragsDialog;
        return (matchValue.tag === 0) ? append_1(singleton_1(newNavigationTile(model_1, dispatch, userSession, props)), delay(() => {
            let children_4, props_13;
            const usePdfViewer = isNullOrEmpty(model_1.Data.VertragsText);
            return singleton_1(messageBoxComponent(new GlobalMessageType(1, []), usePdfViewer, "Wir aktualisieren unsere Vereinbarung", (children_4 = toList(delay(() => {
                let elems, s, props_5;
                return usePdfViewer ? singleton_1(createElement("object", createObj(ofArray([["className", "pdf"], ["data", `/api/dashboard/${model_1.Data.VertragsNummer}.pdf`], (elems = [createElement("p", {
                    children: [(s = "Der Vertragstext kann in Ihrem Browser leider nicht angezeigt werden. Bitte speichern Sie ihn auf Ihrem Gerät und öffnen ihn anschließend mit der entsprechenden Anwendung.", s)],
                }), createElement("br", {}), createElement("a", {
                    href: `/api/dashboard/${model_1.Data.VertragsNummer}.pdf`,
                    children: "Vertragstext speichern",
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : append_1(singleton_1((props_5 = [new HTMLAttr(65, ["content"]), new DOMAttr(0, [new DangerousHtml(Markdown_ToHtml_1BFEAEDB(model_1.Data.VertragsText))])], react.createElement("div", keyValueList(props_5, 1)))), delay(() => append_1(singleton_1(react.createElement("p", {}, "\n")), delay(() => singleton_1(validatedTextBox((s_2) => {
                    dispatch(new Msg(2, [s_2]));
                })("Name:")("Name")("Vorname Nachname")(model_1.Name))))));
            })), react.createElement("div", {}, ...children_4)), () => {
                dispatch(new Msg(4, []));
            }, [react.createElement("button", {
                className: "button is-bfscolored",
                onClick: (_arg_2) => {
                    dispatch(new Msg(4, []));
                },
            }, "Abbrechen"), (props_13 = [new HTMLAttr(65, ["button is-bfscolored"]), new HTMLAttr(79, [!FormField__get_IsValid(model_1.Name)]), new DOMAttr(40, [(_arg_3) => {
                dispatch(new Msg(5, []));
            }])], react.createElement("button", keyValueList(props_13, 1), "Neuen Vertrag bestätigen"))]));
        })) : ((matchValue.tag === 2) ? singleton_1(messageBoxComponent(new GlobalMessageType(1, []), false, "Wir aktualisieren unsere Vereinbarung", (children_12 = [(children_10 = [(s_5 = "Vielen Dank für Ihre Zustimmung.\nEin PDF mit dem Text der Vereinbarung erhalten Sie in Kürze in Ihrem Kundenportal als Dokument zugestellt.", s_5)], react.createElement("p", {}, ...children_10))], react.createElement("div", {}, ...children_12)), () => {
            dispatch(new Msg(7, []));
        }, [react.createElement("button", {
            className: "button is-bfscolored",
            onClick: (_arg_4) => {
                dispatch(new Msg(7, []));
            },
        }, "Ok")])) : ((matchValue.tag === 3) ? singleton_1(react.createElement("div", {})) : singleton_1(newNavigationTile(model_1, dispatch, userSession, props))));
    }));
    return react.createElement("div", {}, ...children_18);
}, undefined, undefined, "Of");

//# sourceMappingURL=VertragsBestaetigung.fs.js.map
